// extracted by mini-css-extract-plugin
export default {"rating":"dG-z","numberOfStars":"eG-z","count":"fG-z","barGraphSpacing":"gG-z","barGraph":"hG-z"};